// QuoteFormDrawer's writes (finance-real, the user 2026-10-22): a new quote, or an existing one's title and jobs.
import type { UseMutationResult } from "@tanstack/react-query";
import { useCreateQuote, useUpdateQuote } from "../../hooks/useLineJobs";
import type { QuoteBundle, QuoteInput } from "../../types";

export interface QuoteFormDrawerModel {
  create: UseMutationResult<QuoteBundle, Error, QuoteInput>;
  update: UseMutationResult<QuoteBundle, Error, { quoteId: string; input: Partial<QuoteInput> }>;
}

export function useQuoteFormDrawer(clientId: string): QuoteFormDrawerModel {
  const create = useCreateQuote(clientId);
  const update = useUpdateQuote();
  return { create, update };
}
